module.exports = __webpack_public_path__ + "fd6aa86ec4d0e83e9d81f206db3f66f2.jpg";